module.exports = __webpack_public_path__ + "assets/img/24_325.c694cf12.jpg";